import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import Extend from 'flarum/common/extenders';
import { extend as extendComponent, override } from 'flarum/common/extend';
import Post from 'flarum/common/models/Post';
import PostsUserPage from 'flarum/forum/components/PostsUserPage';
import PostControls from 'flarum/forum/utils/PostControls';
import commonExtend from '../common/extend';
import DeclarationList from './components/DeclarationList';
import SourceDeclaration from './components/SourceDeclaration';
import { selectionsFromModels } from './utils/declarations';
export const extend = [...commonExtend, new Extend.Model(Post).hasMany('creatorDeclarations').attribute('canEditCreatorDeclarations')];
function initializeDeclarationComposer(composerBody) {
  composerBody.composer.fields.creatorDeclarations = composerBody.composer.fields.creatorDeclarations || [];
  composerBody.chooseCreatorDeclarations = function () {
    app.modal.show(() => import(/* webpackChunkName: 'forum/components/DeclarationModal', webpackMode: 'lazy-once' */ './components/DeclarationModal'), {
      selected: this.composer.fields.creatorDeclarations.map(item => ({
        ...item
      })),
      onsave: selected => {
        this.composer.fields.creatorDeclarations = selected;
        m.redraw();
      }
    });
  };
}
function addComposerDeclarationButton(composerBody, items) {
  const selected = composerBody.composer.fields.creatorDeclarations || [];
  items.add('creatorDeclarations', m(Button, {
    className: "Button Button--link Composer-creatorDeclarations",
    icon: "fas fa-file-signature",
    onclick: composerBody.chooseCreatorDeclarations.bind(composerBody)
  }, selected.length ? app.translator.trans('ffans-creator-declarations.forum.composer.selected', {
    count: selected.length
  }) : app.translator.trans('ffans-creator-declarations.forum.composer.choose')), 5);
}
function getCreatorDeclarations(post) {
  const declarations = post.creatorDeclarations();
  return Array.isArray(declarations) ? declarations : [];
}
async function loadCreatorDeclarations(post) {
  if (!Array.isArray(post.creatorDeclarations())) {
    await app.store.find('posts', post.id(), {
      include: 'creatorDeclarations'
    });
  }
  return getCreatorDeclarations(post);
}
function shouldShowCreatorDeclarations() {
  return !app.current.matches(PostsUserPage) || app.forum.attribute('creatorDeclarationShowInUserPostLists') === true;
}
app.initializers.add('ffans-creator-declarations', () => {
  extendComponent('flarum/forum/states/PostListState', 'requestParams', function (params) {
    if (params.filter?.author && !app.forum.attribute('creatorDeclarationShowInUserPostLists')) {
      return;
    }
    params.include ||= [];
    if (!params.include.includes('creatorDeclarations')) {
      params.include.push('creatorDeclarations');
    }
  });
  extendComponent('flarum/forum/components/DiscussionComposer', 'oninit', function () {
    initializeDeclarationComposer(this);
  });
  extendComponent('flarum/forum/components/ReplyComposer', 'oninit', function () {
    if (!this.constructor.focusOnSelector) {
      this.constructor.focusOnSelector = () => '.ComposerBody-editor :input:enabled:visible, .ComposerBody-editor .TextEditor-editor';
    }
    initializeDeclarationComposer(this);
  });
  extendComponent('flarum/forum/components/DiscussionComposer', 'headerItems', function (items) {
    addComposerDeclarationButton(this, items);
  });
  extendComponent('flarum/forum/components/ReplyComposer', 'headerItems', function (items) {
    addComposerDeclarationButton(this, items);
  });
  extendComponent('flarum/forum/components/DiscussionComposer', 'data', function (data) {
    data.creatorDeclarationData = this.composer.fields.creatorDeclarations || [];
  });
  extendComponent('flarum/forum/components/ReplyComposer', 'data', function (data) {
    data.creatorDeclarationData = this.composer.fields.creatorDeclarations || [];
  });
  override('flarum/forum/components/DiscussionComposer', 'onsubmit', function (original) {
    const selected = this.composer.fields.creatorDeclarations || [];
    if (app.forum.attribute('creatorDeclarationsRequiredForDiscussion') && !selected.length) {
      this.chooseCreatorDeclarations();
      return;
    }
    original();
  });
  override('flarum/forum/components/ReplyComposer', 'onsubmit', function (original) {
    const selected = this.composer.fields.creatorDeclarations || [];
    if (app.forum.attribute('creatorDeclarationsRequiredForReply') && !selected.length) {
      this.chooseCreatorDeclarations();
      return;
    }
    original();
  });
  extendComponent('flarum/forum/components/CommentPost', 'content', function (content) {
    if (!shouldShowCreatorDeclarations()) {
      return;
    }
    const declarations = getCreatorDeclarations(this.attrs.post);
    const comment = content.find(item => item?.attrs?.contentHtml !== undefined);
    if (declarations?.length && comment) {
      comment.attrs.creatorDeclarations = declarations;
    }
  });
  extendComponent('flarum/forum/components/Comment', 'view', function (content) {
    const declarations = this.attrs.creatorDeclarations;
    const bodyIndex = content.findIndex(item => item?.attrs?.className === 'Post-body');
    if (declarations?.length && bodyIndex !== -1) {
      content.splice(bodyIndex, 0, m(DeclarationList, {
        declarations: declarations
      }), m(SourceDeclaration, {
        declarations: declarations
      }));
    }
  });
  extendComponent(PostControls, 'moderationControls', function (items, post) {
    if (post.contentType() !== 'comment' || !post.canEditCreatorDeclarations()) return;
    items.add('creatorDeclarations', m(Button, {
      icon: "fas fa-bullhorn",
      onclick: async () => {
        const selected = selectionsFromModels(await loadCreatorDeclarations(post));
        app.modal.show(() => import(/* webpackChunkName: 'forum/components/DeclarationModal', webpackMode: 'lazy-once' */ './components/DeclarationModal'), {
          selected,
          showDisabled: !!app.session.user?.isAdmin(),
          onsave: next => post.save({
            creatorDeclarationData: next
          })
        });
      }
    }, app.translator.trans('ffans-creator-declarations.forum.controls.edit')));
  });
});flarum.reg.addChunkModule('447', '137', 'ffans-creator-declarations', 'forum/components/DeclarationModal');